module.exports = __webpack_public_path__ + "static/media/umer-bg.4a6a4a07.jpg";